import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../../reports/reports.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-zone-seat-status-report',
  templateUrl: './zone-seat-status-report.component.html',
  styleUrls: ['./zone-seat-status-report.component.less']
})
export class ZoneSeatStatusReportComponent implements OnInit {

  records: any[] = [];

  model: any = {
    eventId: null
  };

  constructor(private service: ReportsService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.subscribe(paramMap => {
      this.model.eventId = Number(paramMap.get('id'));
      if (!this.model.eventId) {
        return;
      }

      this.load();
    });
  }

  load() {
    this.service.getZoneSeatStatsByStatus(this.model)
      .subscribe(data => {
        this.records = data as any[];
      });
  }

}
